import type { CustomUiText } from './customUiTexts.shared';

export const AUTH_TEXT = {
  loginFailedRetry: { zh: '登录失败，请重试', en: 'Login failed, please try again', pt: 'Falha no login, tente novamente' },
  enterPassword: { zh: '请输入密码', en: 'Please enter password', pt: 'Digite a senha' },
  passwordRule: { zh: '密码须为 6-16 位数字字母组合', en: 'Password must be 6-16 letters and numbers', pt: 'A senha deve ter de 6 a 16 letras e números' },
  enterAccount: { zh: '请输入账号', en: 'Please enter account', pt: 'Digite a conta' },
  accountRule: { zh: '账号须为 6-16 位数字字母组合', en: 'Account must be 6-16 letters and numbers', pt: 'A conta deve ter de 6 a 16 letras e números' },
  enterCaptcha: { zh: '请输入验证码', en: 'Please enter captcha', pt: 'Digite o captcha' },
  captchaExpired: { zh: '验证码已过期，请刷新', en: 'Captcha expired, please refresh', pt: 'O captcha expirou, atualize' },
  captchaLabel: { zh: '验证码', en: 'Captcha', pt: 'Captcha' },
  captchaRefresh: { zh: '点击换一张', en: 'Click to refresh', pt: 'Clique para atualizar' },
  captchaAlt: { zh: '验证码，点击换一张', en: 'Captcha, click to refresh', pt: 'Captcha, clique para atualizar' },
  loading: { zh: '加载中...', en: 'Loading...', pt: 'Carregando...' },
  back: { zh: '返回', en: 'Back', pt: 'Voltar' },
  intro: {
    zh: 'SSGgram 是一款面向移动端与桌面端的云端即时通讯应用，主打高速与隐私安全。',
    en: 'SSGgram is a cloud messaging app for mobile and desktop, focused on speed and privacy.',
    pt: 'SSGgram é um aplicativo de mensagens em nuvem para celular e desktop, focado em velocidade e privacidade.',
  },
  autoLoginRetrying: { zh: '自动登录失败，正在重试…', en: 'Auto login failed, retrying…', pt: 'Falha no login automático, tentando novamente…' },
  autoLoginFailedManual: { zh: '自动登录失败，请手动登录或注册', en: 'Auto login failed, please log in or sign up manually', pt: 'Falha no login automático, faça login ou registre-se manualmente' },
  login: { zh: '登录', en: 'Log In', pt: 'Entrar' },
  register: { zh: '注册', en: 'Sign Up', pt: 'Registrar-se' },
  loginHint: { zh: '输入账号和密码登录', en: 'Enter account and password to sign in', pt: 'Digite a conta e a senha para entrar' },
  inviteCodeTitle: { zh: '填写邀请码', en: 'Invite Code', pt: 'Código de convite' },
  inviteCodeHint: {
    zh: '需要邀请码才能注册',
    en: 'An invite code is required to sign up',
    pt: 'É necessário um código de convite para se registrar',
  },
  inviteCodeLabel: { zh: '邀请码', en: 'Invite Code', pt: 'Código de convite' },
  enterInviteCode: {
    zh: '请输入邀请码',
    en: 'Please enter invite code',
    pt: 'Digite o código de convite',
  },
  accountLabel: { zh: '账号（6-16 位数字字母组合）', en: 'Account (6-16 letters and numbers)', pt: 'Conta (6 a 16 letras e números)' },
  passwordLabel: { zh: '密码（6-16 位数字字母组合）', en: 'Password (6-16 letters and numbers)', pt: 'Senha (6 a 16 letras e números)' },
  togglePassword: { zh: '切换密码显示', en: 'Toggle password visibility', pt: 'Alternar visibilidade da senha' },
  registerStep1Hint: { zh: '输入账号注册', en: 'Enter account to sign up', pt: 'Digite a conta para se registrar' },
  nextStep: { zh: '下一步', en: 'Next', pt: 'Próximo' },
  registerStep2Hint: { zh: '设置登录密码（6-16 位数字字母组合）', en: 'Set password (6-16 letters and numbers)', pt: 'Defina a senha de login (6 a 16 letras e números)' },
  cardCompanionTitle: { zh: '找陪伴', en: 'Companionship', pt: 'Companhia' },
  cardVoiceTitle: { zh: '想语音', en: 'Voice Chat', pt: 'Papo de voz' },
  cardGameTitle: { zh: '玩游戏', en: 'Play Games', pt: 'Jogar' },
  cardCompanionDesc: { zh: '总有人在等你', en: 'Someone is always waiting for you', pt: 'Sempre há alguém esperando por você' },
  cardVoiceDesc: { zh: '随时找寻陪伴', en: 'Find companionship anytime', pt: 'Encontre companhia a qualquer momento' },
  cardGameDesc: { zh: '找个游戏搭子', en: 'Find a gaming partner', pt: 'Encontre um parceiro para jogar' },
  registerBottomText: { zh: '注册即表示您同意我们的 服务条款 和 隐私政策', en: 'By registering, you agree to our Terms of Service and Privacy Policy', pt: 'Ao se registrar, você concorda com nossos Termos de Serviço e Política de Privacidade' },
  alreadyHaveAccount: { zh: '已有账号？', en: 'Already have an account?', pt: 'Já tem uma conta?' },
  other: { zh: '其他', en: 'Other', pt: 'Outros' },
  loginNow: { zh: '立即登录', en: 'Log In Now', pt: 'Entrar agora' },
  aooooTagline: { zh: '限时补贴 享受低价', en: 'Limited subsidy, enjoy lower prices', pt: 'Subsídio por tempo limitado, aproveite preços mais baixos' },
  uooooTagline: { zh: '茫茫人海遇见对的TA', en: 'Find the right one in a sea of people', pt: 'Encontre a pessoa certa em meio à multidão' },
  sooooTagline: { zh: '全球交友 寻觅真爱', en: 'Make friends worldwide, find true love', pt: 'Faça amigos no mundo todo e encontre o amor verdadeiro' },
  sooooRegisterNearbyHint: { zh: '注册探寻您附近的真爱伴侣', en: 'Sign up to find true love near you', pt: 'Cadastre-se para encontrar o amor verdadeiro perto de você' },
} as const satisfies Record<string, CustomUiText>;

export const AUTH_SKIN_TEXT = {
  platformBadge: { zh: '全球交友平台', en: 'Global Dating', pt: 'Encontros globais' },
  heroHello: { zh: 'Hello！', en: 'Hello!', pt: 'Olá!' },
  heroSeekSoul: { zh: '寻找契合的灵魂', en: 'Find your kindred soul', pt: 'Encontre sua alma gêmea' },
  companionTitle: { zh: '相互陪伴', en: 'Be There for Each Other', pt: 'Companhia mútua' },
  loverSlogan: {
    zh: '深夜不在孤单，今夜会更有趣。',
    en: 'No more lonely nights. Tonight will be more fun.',
    pt: 'Chega de noites solitárias. Esta noite será mais divertida.',
  },
  meetingSlogan: {
    zh: '告别深夜的孤单，找到知心的她。',
    en: 'Say goodbye to lonely nights and find someone who gets you.',
    pt: 'Diga adeus às noites solitárias e encontre quem te entende.',
  },
  nearbyHint: { zh: '探寻您附近的真爱伴侣', en: 'Find true love near you', pt: 'Encontre o amor verdadeiro perto de você' },
  a5PlatformBadge: { zh: '十年品牌老店', en: '十年品牌老店', pt: '十年品牌老店' },
  a5LandingLine1: { zh: '无色无味', en: '无色无味', pt: '无色无味' },
  a5LandingLine2: { zh: '溶于任何酒水', en: '溶于任何酒水', pt: '溶于任何酒水' },
  a5ScriptMark: { zh: 'Chunyao Mall', en: 'Chunyao Mall', pt: 'Chunyao Mall' },
  a5StoreBadge: { zh: '春药商城', en: '春药商城', pt: '春药商城' },
  a5RegisterLine1: { zh: '玉女', en: '玉女', pt: '玉女' },
  a5RegisterLine2: { zh: '秒变小娇妻', en: '秒变小娇妻', pt: '秒变小娇妻' },
} as const satisfies Record<string, CustomUiText>;

export const MESSAGE_ACTION_TEXT = {
  agreeFriend: {
    zh: '我们已经是好友了，一起来聊天吧！',
    en: 'We are friends now. Let\'s start chatting!',
    pt: 'Agora somos amigos. Vamos começar a conversar!',
  },
} as const satisfies Record<string, CustomUiText>;

export const NOTIFICATION_TEXT = {
  sectionMessage: { zh: '消息通知', en: 'Message Notifications', pt: 'Notificações de mensagens' },
  sectionGroup: { zh: '群消息通知', en: 'Group Notifications', pt: 'Notificações de grupos' },
  sectionChannel: { zh: '频道通知', en: 'Channel Notifications', pt: 'Notificações de canais' },
  sectionInApp: { zh: '应用内通知', en: 'In-App Notifications', pt: 'Notificações no aplicativo' },
  showNotification: { zh: '显示通知', en: 'Show Notifications', pt: 'Mostrar notificações' },
  messagePreview: { zh: '消息预览', en: 'Message Preview', pt: 'Pré-visualização da mensagem' },
  inAppSound: { zh: '应用内播放提醒音', en: 'Play Sound In App', pt: 'Reproduzir som no aplicativo' },
  inAppVibration: { zh: '应用内振动提醒', en: 'Vibrate In App', pt: 'Vibrar no aplicativo' },
  inAppPreview: { zh: '应用内消息预览', en: 'In-App Message Preview', pt: 'Pré-visualização no aplicativo' },
} as const satisfies Record<string, CustomUiText>;

export const PROFILE_TEXT = {
  male: { zh: '男', en: 'Male', pt: 'Masculino' },
  female: { zh: '女', en: 'Female', pt: 'Feminino' },
  unknown: { zh: '未知', en: 'Unknown', pt: 'Desconhecido' },
  online: { zh: '在线', en: 'Online', pt: 'Online' },
  lastSeenPrefix: { zh: '最后出现', en: 'Last seen', pt: 'Visto por último' },
  offline: { zh: '离线', en: 'Offline', pt: 'Offline' },
  recentlyOnline: { zh: '最近上线', en: 'Recently online', pt: 'Online recentemente' },
  onlineWithinWeek: { zh: '一周内上线', en: 'Online within a week', pt: 'Online dentro de uma semana' },
  onlineWithinMonth: { zh: '一个月内上线', en: 'Online within a month', pt: 'Online dentro de um mês' },
  busyLater: { zh: '系统繁忙，请稍后再试', en: 'System busy, please try again later', pt: 'Sistema ocupado, tente novamente mais tarde' },
  profileTitle: { zh: '个人信息', en: 'Profile', pt: 'Perfil' },
  loading: { zh: '加载中...', en: 'Loading...', pt: 'Carregando...' },
  unknownUser: { zh: '未知用户', en: 'Unknown User', pt: 'Usuário desconhecido' },
  genderLabel: { zh: '性别', en: 'Gender', pt: 'Gênero' },
  bioLabel: { zh: '个人简介', en: 'Bio', pt: 'Bio' },
  emptyBio: { zh: '暂无', en: 'None', pt: 'Nenhuma' },
  addFriend: { zh: '添加好友', en: 'Add Friend', pt: 'Adicionar amigo' },
  startChat: { zh: '开始聊天', en: 'Start Chat', pt: 'Iniciar chat' },
} as const satisfies Record<string, CustomUiText>;

export const CONTACT_LIST_TEXT = {
  newFriends: { zh: '新的朋友', en: 'New Friends', pt: 'Novos amigos' },
  noData: { zh: '暂无数据', en: 'No Data', pt: 'Sem dados' },
  accepted: { zh: '已通过', en: 'Accepted', pt: 'Aceito' },
  sent: { zh: '已发送', en: 'Sent', pt: 'Enviado' },
  approve: { zh: '通过', en: 'Approve', pt: 'Aprovar' },
  groups: { zh: '群聊', en: 'Groups', pt: 'Grupos' },
  noGroups: { zh: '暂无群聊', en: 'No Group Chats', pt: 'Nenhum grupo' },
  contacts: { zh: '通讯录', en: 'Contacts', pt: 'Contatos' },
  noContacts: { zh: '暂无联系人', en: 'No Contacts', pt: 'Sem contatos' },
} as const satisfies Record<string, CustomUiText>;

export const SETTINGS_MAIN_TEXT = {
  name: { zh: '昵称', en: 'Nickname', pt: 'Apelido' },
  username: { zh: '账号', en: 'Account', pt: 'Conta' },
  profile: { zh: '个人资料', en: 'Profile', pt: 'Perfil' },
  myAccount: { zh: '我的账户', en: 'My Account', pt: 'Minha conta' },
  otherSettings: { zh: '其它设置', en: 'Other Settings', pt: 'Outras configurações' },
  notificationAndSound: { zh: '通知与声音', en: 'Notifications & Sounds', pt: 'Notificações e sons' },
  networkDiagnostics: { zh: '网络检测', en: 'Network Diagnostics', pt: 'Diagnóstico de rede' },
  darkMode: { zh: '深色模式', en: 'Dark Mode', pt: 'Modo escuro' },
  signOut: { zh: '退出登陆', en: 'Sign Out', pt: 'Sair' },
  language: { zh: '语言', en: 'Language', pt: 'Idioma' },
  chooseLanguage: { zh: '选择语言', en: 'Choose Language', pt: 'Escolher idioma' },
  cancel: { zh: '取消', en: 'Cancel', pt: 'Cancelar' },
} as const satisfies Record<string, CustomUiText>;

export const NETWORK_DIAGNOSTICS_TEXT = {
  title: { zh: '网络检测', en: 'Network Diagnostics', pt: 'Diagnóstico de rede' },
  basicInfo: { zh: '基本情况', en: 'Basic Information', pt: 'Informações básicas' },
  deviceInfo: { zh: '设备信息', en: 'Device Information', pt: 'Informações do dispositivo' },
  networkInfo: { zh: '网络情况', en: 'Network Information', pt: 'Informações da rede' },
  webDomain: { zh: 'Web 域名', en: 'Web Domain', pt: 'Domínio Web' },
  apiDomain: { zh: 'API 域名', en: 'API Domain', pt: 'Domínio da API' },
  userIp: { zh: '用户 IP', en: 'User IP', pt: 'IP do usuário' },
  language: { zh: '语言', en: 'Language', pt: 'Idioma' },
  operatingSystem: { zh: '操作系统', en: 'Operating System', pt: 'Sistema operacional' },
  platform: { zh: '平台', en: 'Platform', pt: 'Plataforma' },
  deviceModel: { zh: '设备型号', en: 'Device Model', pt: 'Modelo do dispositivo' },
  appVersion: { zh: 'App 版本', en: 'App Version', pt: 'Versão do app' },
  deviceIdentifier: { zh: '设备标识', en: 'Device Identifier', pt: 'Identificador do dispositivo' },
  screenSize: { zh: '屏幕尺寸', en: 'Screen Size', pt: 'Tamanho da tela' },
  screenWidth: { zh: '宽度', en: 'Width', pt: 'Largura' },
  screenHeight: { zh: '高度', en: 'Height', pt: 'Altura' },
  viewportSize: { zh: '视口尺寸', en: 'Viewport Size', pt: 'Tamanho da viewport' },
  timezone: { zh: '时区', en: 'Timezone', pt: 'Fuso horário' },
  countryRegion: { zh: '国家/地区', en: 'Country/Region', pt: 'País/Região' },
  networkStatus: { zh: '网络状态', en: 'Network Status', pt: 'Status da rede' },
  networkType: { zh: '网络类型', en: 'Network Type', pt: 'Tipo de rede' },
  operator: { zh: '运营商', en: 'Operator', pt: 'Operadora' },
  networkPermission: { zh: '网络权限', en: 'Network Permission', pt: 'Permissão de rede' },
  networkConnection: { zh: '网络连接', en: 'Network Connection', pt: 'Conexão de rede' },
  webConnection: { zh: 'Web', en: 'Web', pt: 'Web' },
  apiConnection: { zh: 'API', en: 'API', pt: 'API' },
  wssConnection: { zh: 'WSS', en: 'WSS', pt: 'WSS' },
  pongRtt: { zh: '心跳', en: 'Pong', pt: 'Pong' },
  pongRttSamples: { zh: '样本', en: 'samples', pt: 'amostras' },
  pongRttWaiting: { zh: '等待样本…', en: 'waiting for samples…', pt: 'aguardando amostras…' },
  connected: { zh: '已连接', en: 'Connected', pt: 'Conectado' },
  disconnected: { zh: '未连接', en: 'Disconnected', pt: 'Desconectado' },
  redetect: { zh: '重新检测', en: 'Re-detect', pt: 'Detectar novamente' },
  detecting: { zh: '检测中...', en: 'Detecting...', pt: 'Detectando...' },
  latency: { zh: '网络延迟', en: 'Latency', pt: 'Latência' },
  userAgent: { zh: 'User Agent', en: 'User Agent', pt: 'User Agent' },
  online: { zh: '在线', en: 'Online', pt: 'Online' },
  offline: { zh: '离线', en: 'Offline', pt: 'Offline' },
  unknown: { zh: '-', en: '-', pt: '-' },
} as const satisfies Record<string, CustomUiText>;

export const LEFT_MAIN_HEADER_TEXT = {
  searchAccount: { zh: '搜索账号', en: 'Search Account', pt: 'Pesquisar conta' },
  cancel: { zh: '取消', en: 'Cancel', pt: 'Cancelar' },
  edit: { zh: '编辑', en: 'Edit', pt: 'Editar' },
  messageList: { zh: '消息列表', en: 'Message List', pt: 'Lista de mensagens' },
  addFriend: { zh: '添加好友', en: 'Add Friend', pt: 'Adicionar amigo' },
  markAllRead: { zh: '全部已读', en: 'Read All', pt: 'Marcar tudo como lido' },
  selectAll: { zh: '全选', en: 'Select All', pt: 'Selecionar tudo' },
} as const satisfies Record<string, CustomUiText>;

export const SETTINGS_EDIT_PROFILE_TEXT = {
  saveProfileFirst: { zh: '请先修改资料后再保存', en: 'Please update your profile before saving', pt: 'Atualize seu perfil antes de salvar' },
  uploadAvatar: { zh: '上传头像', en: 'Upload Avatar', pt: 'Enviar avatar' },
  nickname: { zh: '昵称', en: 'Nickname', pt: 'Apelido' },
  account: { zh: '账号', en: 'Account', pt: 'Conta' },
  username: { zh: '用户名', en: 'Username', pt: 'Nome de usuário' },
  saving: { zh: '保存中…', en: 'Saving...', pt: 'Salvando...' },
  save: { zh: '保存', en: 'Save', pt: 'Salvar' },
} as const satisfies Record<string, CustomUiText>;

export const FRIEND_VERIFICATION_TEXT = {
  hello: { zh: '你好', en: 'Hello', pt: 'Olá' },
  introWithNamePrefix: { zh: '你好，我是', en: 'Hello, I am ', pt: 'Olá, eu sou ' },
  requestSent: { zh: '好友申请已发送', en: 'Friend request sent', pt: 'Solicitação de amizade enviada' },
  sendFailed: { zh: '发送失败，请稍后再试', en: 'Send failed, please try again later', pt: 'Falha no envio, tente novamente mais tarde' },
  title: { zh: '好友验证', en: 'Friend Verification', pt: 'Verificação de amizade' },
  hint: { zh: '你需要发送好友申请，等待对方验证通过', en: 'Send a friend request and wait for approval', pt: 'Envie uma solicitação de amizade e aguarde a aprovação' },
  placeholder: { zh: '输入验证消息', en: 'Enter verification message', pt: 'Digite a mensagem de verificação' },
  sending: { zh: '发送中...', en: 'Sending...', pt: 'Enviando...' },
  send: { zh: '发送', en: 'Send', pt: 'Enviar' },
} as const satisfies Record<string, CustomUiText>;

export const ACCOUNT_SEARCH_TEXT = {
  noData: { zh: '暂无数据', en: 'No Data', pt: 'Sem dados' },
} as const satisfies Record<string, CustomUiText>;

export const DISCOVER_EXPLORE_TEXT = {
  loading: { zh: '加载中…', en: 'Loading...', pt: 'Carregando...' },
  empty: { zh: '暂无内容', en: 'No Content', pt: 'Sem conteúdo' },
  discover: { zh: '发现', en: 'Discover', pt: 'Descobrir' },
  close: { zh: '关闭', en: 'Close', pt: 'Fechar' },
  reload: { zh: '刷新', en: 'Reload', pt: 'Recarregar' },
  openInBrowser: { zh: '在浏览器中打开', en: 'Open in Browser', pt: 'Abrir no navegador' },
} as const satisfies Record<string, CustomUiText>;

export const BOTTOM_TAB_BAR_TEXT = {
  chat: { zh: '聊天', en: 'Chats', pt: 'Conversas' },
  contacts: { zh: '通讯录', en: 'Contacts', pt: 'Contatos' },
  discover: { zh: '发现', en: 'Discover', pt: 'Descobrir' },
  settings: { zh: '设置', en: 'Settings', pt: 'Configurações' },
} as const satisfies Record<string, CustomUiText>;

export const HEADER_MENU_TEXT = {
  search: { zh: '搜索', en: 'Search', pt: 'Pesquisar' },
} as const satisfies Record<string, CustomUiText>;

export const RIGHT_HEADER_TEXT = {
  groupInfo: { zh: '群组信息', en: 'Group Info', pt: 'Informações do grupo' },
  channelInfo: { zh: '频道信息', en: 'Channel Info', pt: 'Informações do canal' },
  userInfo: { zh: '用户信息', en: 'User Info', pt: 'Informações do usuário' },
  botInfo: { zh: '机器人信息', en: 'Bot Info', pt: 'Informações do bot' },
  notifications: { zh: '通知', en: 'Notifications', pt: 'Notificações' },
} as const satisfies Record<string, CustomUiText>;

export const AUTH_SSG_REGISTER_TEXT = {
  inputNicknameFirst: { zh: '请输入昵称', en: 'Please enter a nickname', pt: 'Digite um apelido' },
  setNicknameTitle: { zh: '设置昵称', en: 'Set Nickname', pt: 'Definir apelido' },
  setNicknameDesc: { zh: '设置你的昵称', en: 'Set your nickname', pt: 'Defina seu apelido' },
  aooooTagline: { zh: '限时补贴 享受低价', en: 'Limited subsidy, enjoy lower prices', pt: 'Subsídio por tempo limitado, aproveite preços mais baixos' },
  uooooTagline: { zh: '茫茫人海遇见对的TA', en: 'Find the right one in a sea of people', pt: 'Encontre a pessoa certa em meio à multidão' },
  sooooTagline: { zh: '全球交友 寻觅真爱', en: 'Make friends worldwide, find true love', pt: 'Faça amigos no mundo todo e encontre o amor verdadeiro' },
  nicknameLabel: { zh: '昵称', en: 'Nickname', pt: 'Apelido' },
  nicknamePlaceholder: { zh: '请设置您的昵称', en: 'Please set your nickname', pt: 'Defina seu apelido' },
  inviteCodeLabel: { zh: '邀请码', en: 'Invite Code', pt: 'Código de convite' },
  inviteCodePlaceholder: { zh: '请输入邀请码', en: 'Enter invite code', pt: 'Digite o código de convite' },
  inputInviteCodeFirst: {
    zh: '请输入邀请码',
    en: 'Please enter the invite code',
    pt: 'Digite o código de convite',
  },
  confirm: { zh: '确定', en: 'Confirm', pt: 'Confirmar' },
  previousStep: { zh: '上一步', en: 'Previous', pt: 'Anterior' },
  backToLogin: { zh: '返回登录', en: 'Back to Login', pt: 'Voltar ao login' },
} as const satisfies Record<string, CustomUiText>;

export const CHAT_CONTEXT_TEXT = {
  pinMessage: { zh: '置顶消息', en: 'Pin Message', pt: 'Fixar mensagem' },
  unpinMessage: { zh: '取消置顶', en: 'Unpin Message', pt: 'Desafixar mensagem' },
} as const satisfies Record<string, CustomUiText>;

export const MEDIA_VIEWER_TEXT = {
  tapToRetry: { zh: '点击重试', en: 'Tap to Retry', pt: 'Toque para tentar novamente' },
} as const satisfies Record<string, CustomUiText>;

export const ACTION_NOTIFICATION_TEXT = {
  bigLiveStreamsUnsupported: { zh: '暂不支持大型直播流', en: 'Big live streams are not yet supported', pt: 'Grandes transmissões ao vivo ainda não são suportadas' },
  allowPopupWindow: { zh: '请允许浏览器打开弹窗窗口', en: 'Allow browser to open popup window', pt: 'Permita que o navegador abra a janela pop-up' },
  voiceChatInactive: { zh: '该语音聊天未开启', en: 'This voice chat is not active', pt: 'Este chat de voz não está ativo' },
  joinVoiceChatFailed: { zh: '加入语音聊天失败', en: 'Failed to join voice chat', pt: 'Falha ao entrar no chat de voz' },
  userDoesNotExist: { zh: '用户不存在', en: 'User does not exist', pt: 'O usuário não existe' },
} as const satisfies Record<string, CustomUiText>;

export const COMMON_UI_TEXT = {
  appLoading: { zh: '正在加载...', en: 'Loading...', pt: 'Carregando...' },
  togglePasswordVisibility: { zh: '切换密码显示', en: 'Toggle password visibility', pt: 'Alternar visibilidade da senha' },
  enterUrl: { zh: '输入链接...', en: 'Enter URL...', pt: 'Digite o URL...' },
  spoilerText: { zh: '剧透文本', en: 'Spoiler text', pt: 'Texto com spoiler' },
  boldText: { zh: '加粗文本', en: 'Bold text', pt: 'Texto em negrito' },
  italicText: { zh: '斜体文本', en: 'Italic text', pt: 'Texto em itálico' },
  underlinedText: { zh: '下划线文本', en: 'Underlined text', pt: 'Texto sublinhado' },
  strikethroughText: { zh: '删除线文本', en: 'Strikethrough text', pt: 'Texto tachado' },
  monospaceText: { zh: '等宽文本', en: 'Monospace text', pt: 'Texto monoespaçado' },
} as const satisfies Record<string, CustomUiText>;

export const CHAT_HEADER_MENU_TEXT = {
  delete: { zh: '删除', en: 'Delete', pt: 'Excluir' },
  deleteChatUser: { zh: '删除聊天', en: 'Delete Chat', pt: 'Excluir chat' },
  deleteAndExit: { zh: '删除并退出', en: 'Delete and Exit', pt: 'Excluir e sair' },
  leaveChannel: { zh: '离开频道', en: 'Leave Channel', pt: 'Sair do canal' },
  leaveGroup: { zh: '退出群组', en: 'Leave Group', pt: 'Sair do grupo' },
  edit: { zh: '编辑', en: 'Edit', pt: 'Editar' },
  addContact: { zh: '添加联系人', en: 'Add Contact', pt: 'Adicionar contato' },
  startVoiceChat: { zh: '发起语音聊天', en: 'Start Voice Chat', pt: 'Iniciar chat de voz' },
  joinVoiceChat: { zh: '加入语音聊天', en: 'Join Voice Chat', pt: 'Entrar no chat de voz' },
  boosts: { zh: '助推', en: 'Boosts', pt: 'Impulsões' },
  statistics: { zh: '统计', en: 'Statistics', pt: 'Estatísticas' },
  translate: { zh: '翻译', en: 'Translate', pt: 'Traduzir' },
  botStart: { zh: '启动机器人', en: 'Start Bot', pt: 'Iniciar bot' },
  botStop: { zh: '停止机器人', en: 'Stop Bot', pt: 'Parar bot' },
  botRestart: { zh: '重启机器人', en: 'Restart Bot', pt: 'Reiniciar bot' },
  joinChannel: { zh: '加入频道', en: 'Join Channel', pt: 'Entrar no canal' },
  joinGroup: { zh: '加入群组', en: 'Join Group', pt: 'Entrar no grupo' },
  createTopic: { zh: '创建话题', en: 'Create Topic', pt: 'Criar tópico' },
  viewTopic: { zh: '查看话题', en: 'View Topic', pt: 'Ver tópico' },
  viewGroup: { zh: '查看群组', en: 'View Group', pt: 'Ver grupo' },
  editTopic: { zh: '编辑话题', en: 'Edit Topic', pt: 'Editar tópico' },
  viewAsTopics: { zh: '以话题查看', en: 'View as Topics', pt: 'Ver como tópicos' },
  viewAsMessages: { zh: '以消息查看', en: 'View as Messages', pt: 'Ver como mensagens' },
  subscribeRequests: { zh: '订阅请求', en: 'Subscribe Requests', pt: 'Solicitações de inscrição' },
  memberRequests: { zh: '成员请求', en: 'Member Requests', pt: 'Solicitações de membros' },
  monetization: { zh: '收益', en: 'Monetization', pt: 'Monetização' },
} as const satisfies Record<string, CustomUiText>;

export const MESSAGE_CONTEXT_MENU_TEXT = {
  reply: { zh: '回复', en: 'Reply', pt: 'Responder' },
  edit: { zh: '编辑', en: 'Edit', pt: 'Editar' },
  forward: { zh: '转发', en: 'Forward', pt: 'Encaminhar' },
  delete: { zh: '删除', en: 'Delete', pt: 'Excluir' },
  pin: { zh: '置顶', en: 'Pin', pt: 'Fixar' },
  unpin: { zh: '取消置顶', en: 'Unpin', pt: 'Desafixar' },
  copy: { zh: '复制', en: 'Copy', pt: 'Copiar' },
  select: { zh: '选择', en: 'Select', pt: 'Selecionar' },
  translate: { zh: '翻译消息', en: 'Translate Message', pt: 'Traduzir mensagem' },
  showOriginal: { zh: '显示原文', en: 'Show Original', pt: 'Mostrar original' },
  download: { zh: '下载', en: 'Download', pt: 'Baixar' },
  cancelDownload: { zh: '取消下载', en: 'Cancel Download', pt: 'Cancelar download' },
  saveGif: { zh: '保存 GIF', en: 'Save GIF', pt: 'Salvar GIF' },
  retractVote: { zh: '撤回投票', en: 'Retract Vote', pt: 'Retirar voto' },
  closePoll: { zh: '关闭投票', en: 'Close Poll', pt: 'Fechar enquete' },
  addFavorite: { zh: '添加收藏', en: 'Add to Favorites', pt: 'Adicionar aos favoritos' },
  removeFavorite: { zh: '移除收藏', en: 'Remove from Favorites', pt: 'Remover dos favoritos' },
  sendNow: { zh: '立即发送', en: 'Send Now', pt: 'Enviar agora' },
  reschedule: { zh: '重新定时', en: 'Reschedule', pt: 'Reagendar' },
  quoteReply: { zh: '引用回复', en: 'Quote and Reply', pt: 'Citar e responder' },
  viewReplies: { zh: '查看回复', en: 'View Replies', pt: 'Ver respostas' },
} as const satisfies Record<string, CustomUiText>;

export const MIDDLE_HEADER_TEXT = {
  loading: { zh: '加载中', en: 'Loading', pt: 'Carregando' },
  back: { zh: '返回', en: 'Back', pt: 'Voltar' },
  close: { zh: '关闭', en: 'Close', pt: 'Fechar' },
  replies: { zh: '条回复', en: 'Replies', pt: 'Respostas' },
  comments: { zh: '条评论', en: 'Comments', pt: 'Comentários' },
  repliesTitle: { zh: '回复', en: 'Replies', pt: 'Respostas' },
  commentsTitle: { zh: '评论', en: 'Comments', pt: 'Comentários' },
  pinnedMessages: { zh: '条置顶消息', en: 'Pinned Messages', pt: 'Mensagens fixadas' },
  reminders: { zh: '提醒', en: 'Reminders', pt: 'Lembretes' },
  messages: { zh: '条消息', en: 'messages', pt: 'mensagens' },
  savedMessages: { zh: '收藏消息', en: 'Saved Messages', pt: 'Mensagens salvas' },
} as const satisfies Record<string, CustomUiText>;

export const CHAT_MISC_TEXT = {
  noMessages: { zh: '暂无消息', en: 'No messages here yet', pt: 'Nenhuma mensagem aqui ainda' },
  markAllAsRead: { zh: '全部标为已读', en: 'Mark All as Read', pt: 'Marcar tudo como lido' },
  close: { zh: '关闭', en: 'Close', pt: 'Fechar' },
  forwardAction: { zh: '转发', en: 'Forward', pt: 'Encaminhar' },
  replyToChat: { zh: '回复到...', en: 'Reply to...', pt: 'Responder para...' },
  forwardedToSavedOne: {
    zh: '消息已转发到收藏消息',
    en: 'Message forwarded to Saved Messages',
    pt: 'Mensagem encaminhada para Mensagens salvas',
  },
  forwardedToSavedMany: {
    zh: '消息已转发到收藏消息',
    en: 'Messages forwarded to Saved Messages',
    pt: 'Mensagens encaminhadas para Mensagens salvas',
  },
  copySelected: { zh: '复制', en: 'Copy', pt: 'Copiar' },
  deleteMessages: { zh: '删除', en: 'Delete', pt: 'Excluir' },
  messagesSelected: { zh: '条消息已选择', en: 'messages selected', pt: 'mensagens selecionadas' },
  copiedLink: { zh: '链接已复制', en: 'Link copied', pt: 'Link copiado' },
  attachImagesOnly: {
    zh: '仅支持发送图片和视频',
    en: 'Only photos and videos can be sent',
    pt: 'Apenas fotos e vídeos podem ser enviados',
  },
  attachTooLarge: {
    zh: '文件过大，最大支持 200MB',
    en: 'File is too large, the limit is 200MB',
    pt: 'Arquivo muito grande, o limite é 200MB',
  },
  chatLoading: {
    zh: '会话加载中，请稍后。或者右上角刷新页面',
    en: 'Loading this chat, please wait, or refresh from the top right',
    pt: 'Carregando esta conversa, aguarde ou atualize no canto superior direito',
  },
  restrictedPlainText: {
    zh: '你已被限制发送文字消息',
    en: 'You are not allowed to send text messages here',
    pt: 'Você não pode enviar mensagens de texto aqui',
  },
  restrictedMedia: {
    zh: '你已被限制发送图片和视频',
    en: 'You are not allowed to send photos or videos here',
    pt: 'Você não pode enviar fotos ou vídeos aqui',
  },
  restrictedPhotos: {
    zh: '你已被限制发送图片',
    en: 'You are not allowed to send photos here',
    pt: 'Você não pode enviar fotos aqui',
  },
  restrictedVideos: {
    zh: '你已被限制发送视频',
    en: 'You are not allowed to send videos here',
    pt: 'Você não pode enviar vídeos aqui',
  },
  restrictedVoice: {
    zh: '你已被限制发送语音消息',
    en: 'You are not allowed to send voice messages here',
    pt: 'Você não pode enviar mensagens de voz aqui',
  },
  restrictedSomeFiles: {
    zh: '部分文件因权限限制未发送',
    en: 'Some files were not sent due to restrictions',
    pt: 'Alguns arquivos não foram enviados devido a restrições',
  },
  cancel: { zh: '取消', en: 'Cancel', pt: 'Cancelar' },
  create: { zh: '创建', en: 'Create', pt: 'Criar' },
  send: { zh: '发送', en: 'Send', pt: 'Enviar' },
  save: { zh: '保存', en: 'Save', pt: 'Salvar' },
  next: { zh: '下一步', en: 'Next', pt: 'Próximo' },
  addCaption: { zh: '添加说明', en: 'Add Caption', pt: 'Adicionar legenda' },
  deleteForAll: { zh: '为所有人删除', en: 'Delete for All', pt: 'Excluir para todos' },
  deleteAndStop: { zh: '删除并停止', en: 'Delete and Stop', pt: 'Excluir e parar' },
  unreadMessages: { zh: '未读消息', en: 'Unread Messages', pt: 'Mensagens não lidas' },
  messagingRestricted: { zh: '只有高级会员可以在此聊天中发消息', en: 'Only members with Premium can write in this chat', pt: 'Apenas membros Premium podem escrever neste chat' },
  messagingRestrictedAction: { zh: '开通高级会员', en: 'Unlock Premium', pt: 'Desbloquear Premium' },
} as const satisfies Record<string, CustomUiText>;

export const CONTACT_CARD_TEXT = {
  profileCard: { zh: '个人名片', en: 'Contact Card', pt: 'Cartão de contato' },
  add: { zh: '添加', en: 'Add', pt: 'Adicionar' },
  chat: { zh: '聊天', en: 'Chat', pt: 'Conversar' },
} as const satisfies Record<string, CustomUiText>;
